<script setup lang="ts"></script>
<template>
    <div
        class="flex h-dvh w-full justify-center bg-stone-100 bg-cover"
        style="background-image: url(/images/login-bg.webp)"
    >
        <div class="flex hidden grow justify-center px-6 pt-20 lg:flex">
            <!--            <img src="/images/thegreenroom-logo.png" alt="ASKr Logo" class="h-28 w-auto" />-->
        </div>
        <div
            class="ml-auto h-full w-full overflow-y-auto bg-askr-green-700/90 px-6 py-6 text-white md:max-w-xl lg:px-12 xl:max-w-3xl"
        >
            <div class="mb-6 flex justify-center">
                <h1 class="text-3xl font-black tracking-[-0.175rem] text-stone-100">
                    <a href="/">ASKr</a>
                </h1>
            </div>
            <slot />
        </div>
    </div>
</template>
